<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Bank Info List
                    </div>
                    <div class="card-body">
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sortKey === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <!-- <th>Actions</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.id }}</td>
                                        <td>{{ data.bank_name }}</td>
                                        <td>{{ data.account_number }}</td>
                                        <td>{{ data.account_holder_name }}</td>
                                        <td>{{ data.created_at }}</td>
                                        <!-- <td>
                                            <button class="btn btn-option text-primary" @click="editData(data)"><i class="fas fa-edit"></i></button>
                                            <button v-b-modal.bv-modal-delete class="btn btn-option text-danger" @click="deleteData(data)"><i class="fas fa-trash-alt"></i></button>
                                        </td> -->
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <!-- <router-link class="float" to="bank-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'bankList',
        metaInfo: {
            title: "Bank Info List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                dataList: [],
                commissionData: [],
                permissions: '',
                columns: {
                    id: "Bank Info ID",
                    bank_name: "Account Type",
                    account_number: "Account Number",
                    routing_number: "Account Holder Name",
                    created_at: "Created At",
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 10,
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                bankListAction: 'bankListAction',
                bankDeleteAction: 'bankDeleteAction',
            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.bankListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'bank-list', 
                            query: { 
                                page: this.filter.page, 
                                per_page: this.filter.per_page, 
                                sort_direction: this.filter.sort_direction, 
                                sort_by: this.filter.sort_by,
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'bank-list', 
                    query: {
                        page: 1, 
                        per_page: 20, 
                        sort_direction: 'desc', 
                        sort_by: 'created_at',
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.$router.replace({ 
                    path: 'bank-edit', 
                    query: { 
                        page: this.filter.page, 
                        orderBy: this.filter.orderBy, 
                        sortKey: this.filter.sortKey, 
                        id: data.id
                    } 
                }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.bankDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            commissionDetail(data) {
                this.commissionData = data
            },
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>